import { FC } from 'react';
import {
  Create,
  FileField,
  FileInput,
  required,
  SimpleForm,
} from 'react-admin';

export const FileCreate: FC = () => (
  <Create>
    <SimpleForm>
      <FileInput
        source="file"
        label="Файл"
        validate={[required('Нужно прикрепить файл')]}
        placeholder="Перетащите файл сюда или нажмите для загрузки"
      >
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Create>
);
